import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      cartNum : 0 ,//购物车数量
      source : 1,//商城来源
      malMainPageConfig : {},//首页配置
      categoryGoodsLoading:false,//分类商品loading
  },
  mutations: {
      updateCartNum (state, payload) {
          state.cartNum= payload.currentNum
      },
      updateSource (state, payload) {
        state.source= payload.source
      },
      updateMalMainPageConfig (state, payload) {
        state.malMainPageConfig= payload.malMainPageConfig;
        console.log("updateMalMainPageConfig finish!!!!!")
      },
      updateCategoryGoodsLoading(state,payload){
        state.categoryGoodsLoading = payload.loading;
      }
  },
  actions: {

  }
})
